import React from 'react';
import styled from "styled-components";
import Lot from "../Lot";
import Tx from "../Tx";
import ProductInCartRow from "./ProductInCartRow";
import ProductInCart from "./ProductInCart";
import {colors} from "../../maps/colors";
import useZibi from "../../zibi/UseZibi";
import CartViewAction from "./CartViewAction";

const WrapperStyled = styled.div`
`;

const CartStyled = styled.div`
  display: block;
  height: 100%;
`;

const EmptyCartStyled = styled.div`
  color: ${colors.LIGHT_GRAY};
  display: grid;
  justify-content: center;

  .lottie {
    width: 400px;
    margin-left: 210px;

    @media (max-width: 780px) {
      width: 100%;
      overflow: hidden;
      margin: initial;
    }
  }

  svg {
    @media (max-width: 780px) {
      margin-left: 27vw;
    }
  }
`;

const ProductsInCartStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: max-content;
  grid-gap: 13px;
  overflow-y: auto;
  padding: 20px;

  &.tableView {
    grid-template-columns: 1fr;
  }
`;


const CommonProductInCart = ({
                                 productsCart,
                                 productsById,
                                 showEmptyCartIcon = true,
                                 showChangeViewIcon = true,
                                 isPlayMode
                             }) => {
    const isCartEmpty = productsCart.length === 0;
    const [cartViewTable] = useZibi('cartViewTable');

    const style = {};
    if (isPlayMode) {
        style.maxHeight = '100vh';
    } else {
        style.height = '100vh';
    }

    return (
        <WrapperStyled>
            <CartStyled>
                {!isCartEmpty && showChangeViewIcon && (
                    <CartViewAction/>
                )}

                {isCartEmpty && showEmptyCartIcon && (
                    <EmptyCartStyled>
                        <Lot className="lottie">cart</Lot>
                        <Tx>shopper.pleasePickUpTheProduct</Tx>
                    </EmptyCartStyled>
                )}
                {!isCartEmpty && (
                    <ProductsInCartStyled className={cartViewTable ? "tableView" : ""}
                                          style={style}>
                        {productsCart.map((cart, idx) => {
                            const product = productsById[cart.productId];

                            if (!product) {
                                return null;
                            }
                            if (cartViewTable) {
                                return (
                                    <ProductInCartRow
                                        key={product.name + idx}
                                        product={product}
                                    />
                                );
                            }
                            return (
                                <ProductInCart
                                    key={product.name + idx}
                                    product={product}
                                />
                            );
                        })}
                    </ProductsInCartStyled>
                )}
            </CartStyled>
        </WrapperStyled>
    );
};

export default CommonProductInCart;